import axios from "axios";
import { AUTH_API_URL } from "../utils/constants";
import { AXIOS_INSTANCE } from ".";
import { IS_MOCK, MOCK_USER_DATA } from "../utils/mockData";
import { GAME_CATALOG } from "../utils/gameCatalog";

// Plain axios instance — no 401 interceptor.
// This is the initial auth call so there is no session to expire.
const authApi = axios.create();

export const userAuth = async (operatorId) => {
  if (IS_MOCK) {
    return {
      status: 200,
      data: {
        data: { ...MOCK_USER_DATA, operatorId: operatorId || "testOperator" },
      },
    };
  }
  try {
    const token = localStorage.getItem("token");
    const res = await authApi.get(
      `${AUTH_API_URL}/auth/user-info?operatorId=${operatorId}`,
      {
        headers: {
          operatorId,
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const getButtonValuesAPI = async () => {
  if (IS_MOCK) {
    return {
      code: 200,
      response: { bet1: 100, bet2: 500, bet3: 1000, bet4: 5000, bet5: 10000, bet6: 25000 },
    };
  }
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${AUTH_API_URL}/auth/button-values`
    );
    if (data?.code !== undefined) return data;
    return { code: 200, response: data?.data || data };
  } catch (error) {
    return { code: error?.response?.status || 500, response: null };
  }
};

export const changeButtonValuesAPI = async (buttons) => {
  if (IS_MOCK) {
    return { code: 200, response: "Button values updated" };
  }
  try {
    const { data } = await AXIOS_INSTANCE.post(
      `${AUTH_API_URL}/auth/button-values`,
      buttons
    );
    if (data?.code !== undefined) return data;
    return { code: 200, response: data?.data || data };
  } catch (error) {
    return { code: error?.response?.status || 500, response: null };
  }
};

export const changePasswordAPI = async (payload, token) => {
  if (IS_MOCK) {
    return { code: 200, response: "Password changed" };
  }
  try {
    const { data } = await AXIOS_INSTANCE.post(
      `${AUTH_API_URL}/auth/change-password`,
      payload,
      {
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      }
    );
    if (data?.code !== undefined) return data;
    return { code: 200, response: data?.data || data };
  } catch (error) {
    return { code: error?.response?.status || 500, response: null };
  }
};

export const getAnnouncementAPI = async () => {
  if (IS_MOCK) {
    return { code: 200, response: {} };
  }
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${AUTH_API_URL}/auth/announcement`
    );
    if (data?.code !== undefined) return data;
    return { code: 200, response: data?.data || data };
  } catch (error) {
    return { code: error?.response?.status || 500, response: null };
  }
};

export const getExposureTableAPI = async () => {
  if (IS_MOCK) {
    return { code: 200, response: [] };
  }
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${AUTH_API_URL}/auth/exposure-table`
    );
    if (data?.code !== undefined) return data;
    return { code: 200, response: data?.data || data };
  } catch (error) {
    return { code: error?.response?.status || 500, response: null };
  }
};

export const getGameCatalogAPI = async () => {
  if (IS_MOCK) {
    const subset = GAME_CATALOG.slice(0, 8).map((g) => ({
      gameKey: g.gameKey,
      gameCode: g.diamondCode,
      name: g.name,
      category: g.group,
      status: "active",
      minBet: 100.0,
      maxBet: 500000.0,
    }));
    return { code: 200, response: subset };
  }
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${AUTH_API_URL}/casino/game-catalog`
    );
    if (data?.code !== undefined) return data;
    return { code: 200, response: data?.response || data?.data || data };
  } catch (error) {
    return { code: error?.response?.status || 500, response: null };
  }
};
